import routes from '@/modules/accounts/accounts-routes';
import store from '@/modules/accounts/accounts-store';

export default {
    components: [],
    routes,
    store,
};